exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.container .dropdown .dropdown-menu a:hover {\n    color: #fff;\n    background-color: darkgrey;\n    border-color: #fff;\n}\n.limit {\n    max-height:300px;\n    overflow:scroll;\n}\n", ""]);

// exports
